export class Subsidiary {
   constructor(subsidiary_id, subsidiary_name, subsidiary_address, subsidiary_state, subsidiary_city, subsidiary_email, 
               subsidiary_phone_number, subsidiary_trade, subsidiary_petty_cash){
      this.subsidiary_id = subsidiary_id
      this.subsidiary_name = subsidiary_name
      this.subsidiary_address = subsidiary_address
      this.subsidiary_state = subsidiary_state
      this.subsidiary_city = subsidiary_city
      this.subsidiary_email = subsidiary_email
      this.subsidiary_phone_number = subsidiary_phone_number
      this.subsidiary_trade = subsidiary_trade
      this.subsidiary_petty_cash = subsidiary_petty_cash
   }

   static fromServiceSubsidiaries (subsidiary) {
      return new Subsidiary(
         subsidiary.subsidiary_id,
         subsidiary.subsidiary_name,
         subsidiary.subsidiary_address,
         subsidiary.subsidiary_state,
         subsidiary.subsidiary_city,
         subsidiary.subsidiary_email,
         subsidiary.subsidiary_phone_number,
         subsidiary.subsidiary_trade,
         subsidiary.subsidiary_petty_cash
         );
   }   
}
